import {Injectable} from '@angular/core';
import {HttpService} from '../http.service';
import {STREAMING_ROUTE} from '../http-routes';
import {LivestreamStatus} from '@api/models/livestream/streaming-info';
import {IDefaultListResponse} from '@api/models/default-response/response';
import {INewsPost} from '@api/models/news/news';
import {Event} from '@api/models/event/event';
import {SportTypeService} from '@api/services/sport-type/sport-type.service';
import {SportType} from '@lib/models/sport-type/sport-type';

@Injectable({
  providedIn: 'root'
})
export class StreamingHttpService {

  constructor(private http: HttpService) {
  }

  public async getStreamingEventsByStatus(
    status: LivestreamStatus,
    skip = 0,
    limit = 0,
    queryParams?: { stateId?: string, leagueId?: string, teamId?: string, popular?: boolean },
    sportType = SportTypeService.selectedSportType
  ): Promise<IDefaultListResponse<Event>> {
    const query = this.http.buildQueryParams(queryParams);
    const route =
      sportType === SportType.Handball
        ? 'handball/events/streaming'
        : 'streaming/football/events';
    return this.http.get<IDefaultListResponse<Event>>(
      [route, status, skip, limit],
      query
    );
  }

  public async getHandballStreamingEventsByStatus(
    status: LivestreamStatus,
    skip = 0,
    limit = 0,
    queryParams?: { date?: string, filterTodayEvents?: boolean, popular?: boolean },
  ): Promise<IDefaultListResponse<Event>> {
    const query = this.http.buildQueryParams(queryParams);
    return this.http.get<IDefaultListResponse<Event>>(
      ['handball/events/streaming', status, skip, limit],
      query
    );
  }

  public async getVideoNews(
    skip = 0, limit = 0,
    queryParams?: { stateId?: string, leagueId?: string, teamId?: string, editorial?: boolean, trending?: boolean },
  ): Promise<IDefaultListResponse<INewsPost>> {
    const query = this.http.buildQueryParams(queryParams);
    return this.http.get<IDefaultListResponse<INewsPost>>(
      [STREAMING_ROUTE, 'football/news', skip, limit],
      query
    );
  }
}
